import type { Space } from '@cocoonspace/sdk-js/types/space'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { Map } from 'lucide-react'
import { Trans, useTranslation } from 'next-i18next'
import { useCallback } from 'react'
import { Button } from '~/components/ui/button'
import { mapEmitter } from '~/domains/search/emitters/search.emitters'
import { useSearchSpaces } from '~/domains/search/hooks/use-search-spaces.hook'
import type { QueryFilters } from '../filters/use-search-filters.hook'

export const SpacesGroupHeader = ({
	label,
	items,
	isAlternative = false,
	timeSlot,
}: {
	label?: string
	items: Space[]
	timeSlot: {
		day: QueryFilters['day']
		start: QueryFilters['start']
		end: QueryFilters['end']
	}
	isAlternative?: boolean
}) => {
	const { t } = useTranslation()

	const { activeAlternative, setIsMapVisible, setActiveAlternative } =
		useSearchSpaces()

	const onGroupChange = useCallback(() => {
		setIsMapVisible(true)
		setActiveAlternative(label || undefined)

		mapEmitter.emit('map.fitBounds')
	}, [label, setIsMapVisible, setActiveAlternative])

	return (
		<div className='mb-4 flex w-full flex-row items-end gap-4'>
			{!!label && (
				<>
					<h3 className='text-2xl leading-none'>
						<Trans
							i18nKey={`search:results.suggestionsTitles.${label}`}
							values={{
								count: items?.length,
								start: dateTimeUtils(timeSlot.start, 'HH:mm')
									.customFormat('hours')
									.replace('h00', 'h'),
							}}
						/>
					</h3>

					<hr className='hidden w-full flex-1 md:block' />
				</>
			)}

			{activeAlternative !== label && (
				<button
					type='button'
					className='ml-auto hidden shrink-0 font-bold text-primary leading-none md:block'
					onClick={onGroupChange}
				>
					{t('search:actions.displayOnMap')}
				</button>
			)}

			{isAlternative && (
				<Button
					variant='outlinePrimary'
					className='md:hidden'
					onClick={onGroupChange}
				>
					<Map size={16} />
				</Button>
			)}
		</div>
	)
}
